import { render, staticRenderFns } from "./VoiceAIDashboard.vue?vue&type=template&id=a2965ae6&scoped=true"
import script from "./VoiceAIDashboard.vue?vue&type=script&lang=js"
export * from "./VoiceAIDashboard.vue?vue&type=script&lang=js"
import style0 from "./VoiceAIDashboard.vue?vue&type=style&index=0&id=a2965ae6&prod&scoped=true&lang=css"
import style1 from "./VoiceAIDashboard.vue?vue&type=style&index=1&id=a2965ae6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2965ae6",
  null
  
)

export default component.exports